export const NewReportPlusIcon = () => (
    <img className='w-8 h-8' src={`${window.location.origin}/icons/28px_NewReport.svg`} alt="New Page" />
);
